import { Calendar, getCalendarEntry } from 'owa-calendar-cache';
import {
    getCalendars,
    getSelectedCalendars,
    updateStoreCalendars,
} from 'owa-calendar-surface-calendars-store';
import {
    reloadCacheAndSelectCalendar,
    unselectCalendar,
} from 'owa-calendar-surface-select-calendar';

import CalendarActionFolderIdResponse from 'owa-service/lib/contract/CalendarActionFolderIdResponse';
import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import { birthdayCalendarOptionUpdated } from 'owa-calendar-birthday-option/lib/actions/publicActions';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { getCalendarsService } from 'owa-calendarsapi-outlook';
import { orchestrator } from 'satcheljs';

/**
 * The actions for updating birthday calendar settings are defined in owa-calendar-birthday-option package.
 * This orchestrator listens to action dispatched when the birthday calendar settings are updated
 * and accordingly updated the list of selected calendars in the calendar app
 */
export default orchestrator(birthdayCalendarOptionUpdated, async actionMessage => {
    if (actionMessage.birthdayCalendarEnabled) {
        let response: CalendarActionFolderIdResponse = actionMessage.serverResponse;
        if (response?.NewFolderId) {
            await reloadCacheAndSelectCalendar(response.NewFolderId);
        }
    } else {
        // unselect the existing birthday calendar and remove it locally (no need to execute delete service call as the disableBirthdayCalendar has already taken care of it at server side)
        const foundBirthdayCalendarResult = findInArray(getCalendars(), calendar => {
            let calendarEntry: CalendarEntry = getCalendarEntry(calendar);
            return calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.BirthdayCalendar;
        });

        if (foundBirthdayCalendarResult?.item) {
            const birthdayCalendar = foundBirthdayCalendarResult.item;
            const foundSelectedCalendarResult = findInArray(getSelectedCalendars(), calendar => {
                return calendar.id.id == birthdayCalendar.id.id;
            });
            if (foundSelectedCalendarResult) {
                unselectCalendar(birthdayCalendar);
            }

            removeCalendarLocally(birthdayCalendar);
        }

        // finally reload the cache
        // Bug 110838: Calendars cache is not refreshed upon Birthday Calendars setting changed
        await getCalendarsService();
    }
});

/**
 * Removes the given calendar from the calendars list
 */
function removeCalendarLocally(calendarToRemove: Calendar) {
    // Remove calendar from list of calendars instantly
    const foundCalendarResult = findInArray(getCalendars(), item => {
        return item.id == calendarToRemove.id;
    });
    if (foundCalendarResult) {
        let storeCalendars = getCalendars().slice();
        storeCalendars.splice(foundCalendarResult.index, 1);
        updateStoreCalendars(storeCalendars);
    }
}
